export default __webpack_public_path__ + "static/icon_promopackage-7bc5bc85a0f2e9eca630775b032b6217.png";